import { useState } from "react";

type AvatarSize = "sm" | "md" | "lg";

interface AvatarBadgeProps {
  name?: string | null;
  username: string;
  avatarUrl?: string | null;
  size?: AvatarSize;
  alt?: string;
}

function initialsFor(name: string | null | undefined, username: string): string {
  const source = (name || username || "").trim().replace(/@.*$/, "");
  const parts = source.split(/[\s._-]+/).filter(Boolean);

  if (parts.length >= 2) {
    return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
  }

  return (parts[0] || "ID").slice(0, 2).toUpperCase();
}

export function AvatarBadge({ name, username, avatarUrl, size = "md", alt = "" }: AvatarBadgeProps) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const initials = initialsFor(name, username);
  const canShowImage = Boolean(avatarUrl && !failed);

  return (
    <span className={`avatar-badge avatar-badge--${size}`} aria-hidden={alt ? undefined : true}>
      <span className="avatar-badge__initials">{initials}</span>
      {canShowImage && (
        <img
          className={`avatar-badge__image${loaded ? " avatar-badge__image--loaded" : ""}`}
          src={avatarUrl ?? undefined}
          alt={alt}
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
        />
      )}
    </span>
  );
}
